/*
 * *
 *   ~  * Copyright (c) by INFODATA-GROUP. All rights reserved.
 *   ~  * No part of this publication may be reproduced, distributed,
 *   ~  * or transmitted in any form or by any means, including photocopying, recording,
 *   ~  * or other electronic or mechanical methods, without the prior written permission of the publisher,
 *   ~  * except in the case of brief quotations embodied in critical
 *   ~  * reviews and certain other noncommercial uses permitted by copyright law.
 *   ~  * AUTHOR : bs
 *   ~  * DATE : 22/10/2025 17:04
 *
 */

export class ChatMessage {
  id: string;
  content: string;
  sender: 'user' | 'bot' | 'action' | 'response';
  origin: string = null;
  response = false;

  constructor(
    id: string,
    content: string,
    sender: 'user' | 'bot' | 'action' | 'response',
  ) {
    this.id = id;
    this.content = content;
    this.sender = sender;
  }
}
